module.exports = __webpack_public_path__ + "img/logo.f809b975.jpg";